import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('RewardPreview').create(() => ({
  rewardListWrapper: {
    display: 'grid',
    width: '100%',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '8px',
  },

  expensiveWithHeadingnWrapper: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: '12px',
    opacity: 1,
  },
}))
